import startsWithSubDirectory from "./startsWithSubDirectory";
import { getEnv } from "@/env";

const coursePaths = ["course", "learn", "executive-education", "boot-camps"];
const programPaths = [
  "program",
  "bachelors",
  "masters",
  "micromasters",
  "microbachelors",
  "gfa",
  "professional-education",
  "xseries",
  "professional-certificate",
  "doctorate",
  "license",
  "certificates",
];

const getWebviewUrl = (url: string) => {
  const SITE_DOMAIN = getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org");

  const urlObj = url.startsWith("http")
    ? new URL(url)
    : new URL(url, SITE_DOMAIN);
  const urlPath = urlObj.pathname.slice(1); // remove pathname initial "/"
  let urlSearch = urlObj.search ? urlObj.search.slice(1) : "";

  if (coursePaths.some((path) => startsWithSubDirectory(urlPath, path))) {
    return `edxapp://course_info?path_id=${urlPath}${urlSearch && `&${urlSearch}`}`;
  }

  if (
    programPaths.some((path) => startsWithSubDirectory(urlPath, path, true))
  ) {
    return `edxapp://program_info?path_id=${urlPath}${urlSearch && `&${urlSearch}`}`;
  }

  if (startsWithSubDirectory(urlPath, "search")) {
    return `/webview/${urlPath}${urlSearch && `?${urlSearch}`}&device=app&webview=true`;
  }

  // if its not a deep link, just fallback to the regular website
  return `/${urlPath}${urlSearch && `?${urlSearch}`}`;
};

export default getWebviewUrl;
